<template>
  <svg
    :class="`${NAME_PRE}-icon`"
    aria-hidden="true"
    @click="$emit('click',$event)"
  >
    <use :xlink:href="`#${NAME_PRE}-icon-${icon}`"></use>
  </svg>
</template>
<script>
import '../styles/icon/index';
import { NAME_PRE } from '@/packages/constant/index';

export default {
  name: `${NAME_PRE}-icon`,
  props: {
    icon: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      NAME_PRE,
    };
  },
};
</script>
